import { render, staticRenderFns } from "./addnew_tag.vue?vue&type=template&id=662425ec&"
import script from "./addnew_tag.vue?vue&type=script&lang=js&"
export * from "./addnew_tag.vue?vue&type=script&lang=js&"
import style0 from "./addnew_tag.vue?vue&type=style&index=0&id=662425ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports